<script>
  import Timestamp from './Timestamp.svelte';
  import OsIcon from './icons/OsIcon.svelte';
  import { afterUpdate } from 'svelte';

  export let id,appid,appname,start,end,tags;
  export let isSelected = false;
  export let href = '';
  export let showAppName = false;

  let row;

  const dur = () => {
    const ms = (new Date(end) - new Date(start));
    const s = ms / 1000;
    if (s > 3600) return `${Math.round(s/3600)}h`;
    if (s > 60) return `${Math.round(s/60)}m`;
    return `${Math.floor(s)}s`;
  }

  const getTag = (k) => tags?.[k] || '?';

  const ignoreTags = [
    'appID',
    'appName',
    'appVersion',
    'deviceModel',
    'systemVersion',
  ];

	afterUpdate(() => {
		if (isSelected) {
      row.scrollIntoView({block: 'center'});
    }
  });

  $: tagEntries = Object.entries(tags || []).sort()
      .filter(x => !ignoreTags.includes(x[0]));
</script>

<a href={href}>
  <div bind:this={row} class='row' class:isSelected>
    <div class='subrow'>
      <div class='col x3 xl'>
        <Timestamp ts={start}/>
      </div>
      <div class='col x0 xl'>{dur()}</div>
      <div class='col x3 xl'>{getTag('appBuild')}</div>
    </div>
    <div class='subrow'>
      {#if showAppName}
        <div class='col x2 xl'>{appname}</div>
      {/if}
      <div class='col x1 xl'>{getTag('systemName')}</div>
      <div class='col x2'>{getTag('userEmail')}</div>
    </div>
    <div class='subrow'>
      <div class='tags'>
      {#each tagEntries as t, ti}
        <div class='tag'>
          <div class='tk'>{t[0]}</div>
          <div class='tv'>{t[1]}</div>
        </div>
      {/each}
      </div>
    </div>
  </div>
</a>

<style>
  a {
    color: inherit;
  }
  a:hover {
    text-decoration: none;
  }
  .row {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #cccccc1f;
    transition: all 100ms ease-in-out;
  }
  .row:hover {
    background: rgba(204, 204, 204, 0.08);
    cursor: pointer;
  }
  .isSelected {
    color: #ff3f99;
    background: rgba(204, 204, 204, 0.08);
  }
  .subrow {
    display: flex;
    align-items: center;
    transition: all 100ms ease-in-out;
  }
  .col {
    margin: 0.25rem 0.25rem;
  }
  .x0 {
    min-width: 3.5rem;
  }
  .x3 { min-width: 11rem; }
  .x2 { min-width: 8rem; }
  .x1 { min-width: 5rem; }
  .xl { text-align: left; }
  .xr { text-align: right; }
  .xc { text-align: center; }
  .tags {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    display: none;
  }
  .tag {
    display: flex;
    justify-content: center;
    border: 1px solid #cccccc3f;
    border-radius: 4px;
    margin: 0.2rem;
    padding: 3px 4px;
  }
  .tk {
    color: #aeb6cb;
    padding-right: 6px;
    margin-right: 6px;
    border-right: 1px solid #cccccc3f;
  }
  @media (max-width: 640px) {
		.row {
      flex-wrap: wrap;
      flex-direction: column;
		}
	}
</style>
